<template>
    <div>
        <!-- 정보입력 -->
        <div class="join-row-wrap">
            <!-- 정보입련: 일반 -->
            <div class="join-row join-row--form">
                <div class="join-caption join-caption--center">
                    <h3 class="text-20 text-lg-18">기본정보</h3>
                </div>

                <div role="table" class="join-table">
                    <div role="rowgroup">
                        <myinfo-row label="아이디">
                            <input class="input" type="text" name="username" v-model="user.username" @input="input" />
                        </myinfo-row>
                        <myinfo-row label="비밀번호">
                            <v-text-field v-model="user.password" type="password" name="" value="" outlined hide-details class="rounded-0" />
                            <small class="text-grey text-grey--right">(영문대소문자/숫자/특수문자 중 2가지 이상 조합, 8 - 16자)</small>
                        </myinfo-row>
                        <myinfo-row label="비밀번호 확인">
                            <v-text-field v-model="user.passwordConfirm" type="password" name="" value="" outlined hide-details class="rounded-0" />
                        </myinfo-row>
                        <myinfo-row label="이름">
                            <v-text-field v-model="user.name" type="text" class="input rounded-0" outlined hide-details />
                        </myinfo-row>
                        <myinfo-row label="소속/부서">
                            <v-text-field v-model="user.affiliation" type="text" class="rounded-0" outlined hide-details />
                        </myinfo-row>
                        <myinfo-row label="자문분야">
                            <v-col v-for="parent in areas" :key="parent._id" cols="6" lg="">
                                <v-row>
                                    <v-col>{{ parent.name }}</v-col>
                                </v-row>
                                <v-row v-for="child in parent.children" :key="child._id">
                                    <v-col>
                                        <v-checkbox :label="child.name" v-model="user._areas" :value="child._id" @input="input" hide-details dense class="my-0 py-0" />
                                    </v-col>
                                    <v-col cols="12" v-if="child.name == '기타(입력)' && user._areas.includes(child._id)" class="pt-0">
                                        <v-text-field v-model="user.areas_manual[parent._id]" hide-details dense class="my-0 py-0" outlined />
                                    </v-col>
                                </v-row>
                            </v-col>
                        </myinfo-row>
                    </div>
                </div>
            </div>

            <!-- <div class="join-row join-row--form">
                <div class="join-caption join-caption--center">
                    <h3 class="text-20 text-lg-18">공개정보</h3>
                </div>

                <div role="table" class="join-table">
                    <div role="rowgroup">
                        <myinfo-row v-if="isSupporter" label="닉네임">
                            <v-text-field v-model="user.nickname" type="text" class="input rounded-0" outlined hide-details />
                        </myinfo-row>

                        <myinfo-row label="연락처">
                            <v-row align="center">
                                <v-col class="py-0">
                                    <v-select v-model="user.phone1" :items="['010', '011', '016', '017', '019']" outlined hide-details class="rounded-0"></v-select>
                                </v-col>
                                -
                                <v-col class="py-0">
                                    <v-text-field v-model="user.phone2" maxlength="4" outlined hide-details @input="user.phone2 = user.phone2.replace(/[^0-9]/g, '')" class="rounded-0" />
                                </v-col>
                                -
                                <v-col class="py-0">
                                    <v-text-field v-model="user.phone3" maxlength="4" outlined hide-details @input="user.phone2 = user.phone2.replace(/[^0-9]/g, '')" class="rounded-0" />
                                </v-col>
                            </v-row>
                        </myinfo-row>

                        <myinfo-row label="이메일">
                            <v-text-field v-model="user.email" type="text" class="input rounded-0" outlined hide-details />
                        </myinfo-row>
                        <template v-if="isSupporter">
                            <myinfo-row label="전문가 소개">
                                <v-textarea
                                    v-model="user.summary"
                                    type="text"
                                    class="rounded-0"
                                    outlined
                                    hide-details
                                    :placeholder="`기업에서 조회하는 전문가 검색 섹션에 표시되는 부분입니다.\n전문분야 및 경력사항을 소개형태로 50자 이상 작성 부탁드립니다.`"
                                />
                            </myinfo-row>
                            <myinfo-row label="사진">
                                <v-file-input v-model="user.avatar" dense hide-details outlined class="rounded-0" accept="image/*" />
                            </myinfo-row>
                        </template>
                        <template>
                            <myinfo-row>
                                <template slot="title">
                                    <div class="d-flex align-center"><span class="d-inline-block mr-1">정보공개동의</span><bottom-popup v-model="showEvent" /></div>
                                </template>
                                <v-switch label="연락처노출" v-model="user.isContactDisplayed" inset class="ma-0 ml-1" />
                            </myinfo-row>
                        </template>
                    </div>
                </div>
            </div>
            <modify-form-description v-model="user" /> -->
        </div>
        <!-- 하단버튼 -->
        <div class="bottom-button">
            <button class="button button--border-primary" @click="cancel()">
                <span>취소하기</span>
            </button>
            <button class="button button--primary" @click="submit()">
                <span>회원가입</span>
            </button>
        </div>

        <daum-postcode
            ref="daum-postcode"
            @change="
                ({ postcode, address }) => {
                    user.postcode = postcode;
                    user.address1 = address;
                }
            "
        ></daum-postcode>
    </div>
</template>

<script>
import FormRow from "../form-row.vue";
import BottomPopup from "./bottom-popup.vue";
import DaumPostcode from "@/components/plugins/daum/daum-postcode.vue";

import dayjs from "dayjs";
import { INDIVIDUAL_KINDS } from "@/assets/data/CONSTANTS";
import ModifyFormDescription from "@/components/client/experts/modify/modify-form-description.vue";
import MyinfoRow from "@/components/client/mypage/myinfo-row.vue";
import MyinfoAreas from "@/components/client/mypage/myinfo-areas.vue";

const initialUser = {
    kind: INDIVIDUAL_KINDS.SUPPORTER.value,
    affiliation: null,
    // department: null,
    residentNumber: null,
    residentNumber1: null,
    residentNumber2: null,
    postcode: null,
    address1: null,
    address2: null,
    _areas: [],
    areas_manual: {},
    summary: null,
    _avatar: null,
    isContactDisplayed: null,
};
export default {
    components: {
        FormRow,
        BottomPopup,
        DaumPostcode,
        ModifyFormDescription,
        MyinfoRow,
        MyinfoAreas,
    },
    props: ["value", "areas"],
    computed: {
        isSupporter() {
            return this.user.kind == INDIVIDUAL_KINDS.SUPPORTER.value;
        },
    },
    data() {
        return {
            user: { ...initialUser, ...this.$props.value } || { ...initialUser },
            INDIVIDUAL_KINDS,
            showEvent: true,
        };
    },
    methods: {
        input() {
            this.$emit("input", this.user);
        },
        onSearchPostcode() {
            this.$refs["daum-postcode"].open();
        },
        cancel() {
            this.$router.go(-1);
        },

        submit() {
            if (this.validate()) this.$emit("submit", this.user);
        },

        validate() {
            try {
                if (!this.user.username) throw new Error("아이디를 입력해주세요.");
                if (!this.user.password) throw new Error("비밀번호를 입력해주세요.");
                if (!this.checkPassword(this.user.password)) return false;
                if (!this.user.passwordConfirm) throw new Error("비밀번호 확인을 입력해주세요.");
                if (this.user.password != this.user.passwordConfirm) throw new Error("비밀번호를 확인해주세요");
                if (!Object.keys(INDIVIDUAL_KINDS).includes(this.user.kind)) throw new Error("가입유형을 선택해주세요.");
                if (!this.user.name) throw new Error("이름을 입력해주세요.");
                // if (!this.user.nickname) throw new Error("닉네임을 입력해주세요.");
                // if (!this.user.affiliation || !this.user.department) {
                if (!this.user.affiliation) {
                    if (this.user.kind == INDIVIDUAL_KINDS.STUDENT.value) throw new Error("학교/학과를 입력해주세요.");
                    else throw new Error("소속/부서를 입력해주세요.");
                }
                if (!this.isSupporter && !this.checkResidentNumber()) throw new Error("주민등록번호가 잘못되었습니다.");
                // if (!this.user.phone) throw new Error("휴대전화를 입력해주세요.");
                // if (!this.user.email) throw new Error("이메일을 입력해주세요.");
                if (!this.isSupporter && (!this.user.postcode || !this.user.address1 || !this.user.address2)) throw new Error("주소를 입력해주세요.");

                return true;
            } catch (error) {
                alert(error.message);
            }
            return false;
        },

        checkPassword(password) {
            var checkSpecial = /[~!@#$%^&*()_+|<>?:{}]/;
            var checkEng = /[a-zA-Z]/;
            var checkNum = /[0-9]/;

            if (!checkSpecial.test(password)) throw new Error("비밀번호에 특수문자가 포함되어있어야합니다.");
            if (!checkEng.test(password)) throw new Error("비밀번호에 영문이 포함되어있어야합니다.");
            if (!checkNum.test(password)) throw new Error("비밀번호에 숫자가 포함되어있어야합니다.");

            if (password.length < 8 || 16 < password.length) throw new Error("비밀번호는 8~16자까지입니다.");

            return true;
        },

        checkResidentNumber() {
            const { residentNumber, residentNumber1, residentNumber2 } = this.user;
            if (residentNumber?.length !== 14) return false;

            const [yy, mm, dd] = residentNumber1.match(/.{1,2}/g);
            if (+mm < 1 || +mm > 12) return false;
            if (+dd < 1 || +dd > 31) return false;

            return true;
        },
    },
    watch: {
        "user.email"() {
            this.$emit("input", this.user);
        },
        "user.email1"() {
            this.$set(this.user, "email", this.user.email1 && this.user.email2 ? `${this.user.email1}@${this.user.email2}` : null);
        },
        "user.email2"() {
            this.$set(this.user, "email", this.user.email1 && this.user.email2 ? `${this.user.email1}@${this.user.email2}` : null);
        },

        "user.phone"() {
            this.$emit("input", this.user);
        },
        "user.phone1"() {
            this.$set(this.user, "phone", this.user.phone1 && this.user.phone2 && this.user.phone3 ? `${this.user.phone1}-${this.user.phone2}-${this.user.phone3}` : null);
        },
        "user.phone2"() {
            this.$set(this.user, "phone", this.user.phone1 && this.user.phone2 && this.user.phone3 ? `${this.user.phone1}-${this.user.phone2}-${this.user.phone3}` : null);
        },
        "user.phone3"() {
            this.$set(this.user, "phone", this.user.phone1 && this.user.phone2 && this.user.phone3 ? `${this.user.phone1}-${this.user.phone2}-${this.user.phone3}` : null);
        },

        "user.bornAt"() {
            this.$emit("input", this.user);
        },
        "user.residentNumber1"() {
            if (this.user.residentNumber1?.length == 6) {
                const year = dayjs().format("YY");
                const [yy, mm, dd] = this.user.residentNumber1.match(/.{1,2}/g);

                if (this.user.residentNumber2?.length > 0) {
                    const criterion = this.user.residentNumber2[0];
                    this.user.bornAt = [yy.padStart(4, +criterion < 3 ? "19" : "20"), mm, dd].join("-");
                } else this.user.bornAt = [yy.padStart(4, +yy > +year ? "19" : "20"), mm, dd].join("-");
            } else this.user.bornAt = null;

            this.user.residentNumber = `${this.user.residentNumber1}-${this.user.residentNumber2}`;
        },
        "user.residentNumber2"() {
            if (this.user.residentNumber1?.length == 6) {
                const year = dayjs().format("YY");
                const [yy, mm, dd] = this.user.residentNumber1.match(/.{1,2}/g);

                if (this.user.residentNumber2?.length > 0) {
                    const criterion = this.user.residentNumber2[0];
                    this.user.bornAt = [yy.padStart(4, +criterion < 3 ? "19" : "20"), mm, dd].join("-");
                } else this.user.bornAt = [yy.padStart(4, +yy > +year ? "19" : "20"), mm, dd].join("-");
            } else this.user.bornAt = null;

            this.user.residentNumber = `${this.user.residentNumber1}-${this.user.residentNumber2}`;
        },
    },
};
</script>
